import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text/Text'
import { UsedBonusStatus } from 'config/constants/bonus'
import { WageringBonusStatusEnums } from 'config/types/bonus'
import { WageringConditionBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import styled, { css } from 'styled-components'
import { freeSpinBonusFiatReward } from 'utils/bonus'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { ValidatedBonusStatusEnums, useValidateBonus } from 'views/BonusCenter/hooks'

interface BonusItemProps {
  bonus: WageringConditionBonus
  isShowMonochrome?: boolean
}

const WagerProgressBar: React.FC<BonusItemProps & BoxProps> = ({ bonus, isShowMonochrome, ...props }) => {
  const verifyResult = useValidateBonus(bonus)
  const isBonusUsed = [...UsedBonusStatus].concat([ValidatedBonusStatusEnums.Cancelled]).includes(verifyResult)
  const freeSpinCurrency = freeSpinBonusFiatReward(bonus)
  const isPlayToClaimBonus = !bonus.isCreaditReward

  return (
    <Box {...props}>
      <StyledProcessBar
        mt="4px"
        $progress={bonus.progress}
        disabled={
          (bonus.condition.isExpired && bonus.wageringBonusStatus !== WageringBonusStatusEnums.Claimed) ||
          bonus.wageringBonusStatus === WageringBonusStatusEnums.Cancelled
        }
        $isShowMonochrome={isShowMonochrome}
        $isUsed={isBonusUsed}
      />

      <Flex justifyContent="space-between" mt="8px">
        <Flex>
          <Text bold fontSize="12px" letterSpacing="-0.02em" lineHeight="15px" fontWeight={600}>
            {getFullDisplayBalance(bonus.currentWagerBigAmount, 0, 5)}
          </Text>
          <Text bold fontSize="12px" letterSpacing="-0.02em" mx="4px" lineHeight="15px" fontWeight={600}>
            /
          </Text>
          <Text bold fontSize="12px" letterSpacing="-0.02em" lineHeight="15px">
            {getFullDisplayBalance(bonus.targetWagerBigAmount, 0, 5)}
          </Text>
          <Text bold fontSize="12px" color="textAlt1" lineHeight="15px" ml="4px">
            {isPlayToClaimBonus ? 'USD' : bonus.bonusAmount?.token.name || (freeSpinCurrency && freeSpinCurrency.code)}
          </Text>
        </Flex>
        <Text bold fontSize="12px" letterSpacing="-0.02em" lineHeight="15px" fontWeight={600}>
          {bonus.progress}%
        </Text>
      </Flex>
    </Box>
  )
}

const StyledProcessBar = styled(Box)<{
  $progress: number
  disabled?: boolean
  $isUsed: boolean
  $isShowMonochrome: boolean
}>`
  width: 100%;
  height: 12px;
  border-radius: 20px;
  background: #6c727e;
  position: relative;

  &:after {
    content: '';
    width: ${({ $progress }) => $progress}%;
    max-width: calc(100% - 2px);
    height: calc(100% - 2px);
    top: 0.85px;
    left: 1px;
    position: absolute;
    background: ${({ theme, $isUsed, $isShowMonochrome }) =>
      !(typeof $isShowMonochrome === 'boolean')
        ? $isUsed
          ? theme.colors.textSubtle
          : theme.colors.success
        : $isShowMonochrome
        ? theme.colors.textSubtle
        : theme.colors.success};
    border-radius: 20px;
    ${({ disabled }) =>
      disabled &&
      css`
        mix-blend-mode: luminosity;
      `}
  }
`

export default WagerProgressBar
